import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import {
  tutorialParamsBuilder,
  type tutorialParamsType,
} from './useCreateTutorial';
import messages from '../../messages';

type UpdateTutorialPayloadType = tutorialParamsType & {
  uuid: string;
};

const updateTutorial = async (tutorial: UpdateTutorialPayloadType) => {
  const { data } = await putRequest(
    API.PUT.updateTutorial(tutorial.uuid),
    tutorialParamsBuilder(tutorial),
  );
  return data;
};

export const useUpdateTutorial = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateTutorial,
    onSuccess: (_, { uuid }) => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIALS] });
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL, uuid] });
      handleSuccess(formatMessage(messages.tutorialSaved), 1000);
    },
    onError: handleError,
  });
};
